function initSpiLanguageFlags() {
  var flagEls = document.querySelectorAll("[data-flag-lang]");
  if (!flagEls.length) return;

  /* Shopify's localization object gives a language code (e.g. "en", "fr")
     but no flag/country of its own, so this maps common language codes to
     a representative country for display purposes only. */
  var LANGUAGE_TO_COUNTRY = {
    en: "GB", fr: "FR", de: "DE", es: "ES", it: "IT", pt: "PT", nl: "NL",
    hi: "IN", zh: "CN", ja: "JP", ko: "KR", ar: "SA", ru: "RU", tr: "TR",
    pl: "PL", sv: "SE", da: "DK", fi: "FI", no: "NO", cs: "CZ", el: "GR",
    he: "IL", th: "TH", vi: "VN", id: "ID", ms: "MY", uk: "UA", ro: "RO",
    hu: "HU", bg: "BG", hr: "HR", sk: "SK", sl: "SI", et: "EE", lv: "LV",
    lt: "LT", fil: "PH"
  };

  flagEls.forEach(function (el) {
    var langCode = (el.dataset.flagLang || "").toLowerCase().split("-")[0];
    var countryCode = LANGUAGE_TO_COUNTRY[langCode];
    if (countryCode) {
      el.src = "https://flagcdn.com/" + countryCode.toLowerCase() + ".svg";
    } else {
      el.style.display = "none";
    }
  });
}

function initSpiMarqueeCarousel() {
  var carousels = document.querySelectorAll(".spi_top-header-carousel");
  if (!carousels.length) return;

  carousels.forEach(function (root) {
    var slides = root.querySelectorAll(".spi_carousel-slide");
    if (slides.length < 2) return;

    var speed = parseFloat(root.dataset.carouselSpeed) || 5;
    var autoplay = root.dataset.carouselAutoplay !== "false";
    var index = 0;
    var timer;
    var paused = false;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle("spi_active", i === index);
      });
    }

    function restart() {
      window.clearInterval(timer);
      if (!autoplay) return;
      timer = window.setInterval(function () {
        if (!paused) show(index + 1);
      }, speed * 1000);
    }

    var prevBtn = root.querySelector(".spi_carousel-prev");
    var nextBtn = root.querySelector(".spi_carousel-next");

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        show(index - 1);
        restart();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        show(index + 1);
        restart();
      });
    }

    root.addEventListener("mouseenter", function () {
      paused = true;
    });
    root.addEventListener("mouseleave", function () {
      paused = false;
    });

    restart();
  });
}

function initSpiMarqueeScroll() {
  var tracks = document.querySelectorAll(".spi_top-marquee-track");
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    var content = track.querySelector(".spi_top-marquee-content");
    if (!content) return;

    var dup = content.querySelector(".spi_marquee-duplicate");
    var unitNodes = [];
    var node = content.firstElementChild;
    while (node && node !== dup) {
      unitNodes.push(node);
      node = node.nextElementSibling;
    }
    if (!unitNodes.length) return;

    var wrapper = track.closest(".spi_top-header-v2");

    function build() {
      content.innerHTML = "";
      unitNodes.forEach(function (n) {
        content.appendChild(n.cloneNode(true));
      });

      var unitWidth = content.scrollWidth;
      if (!unitWidth) return;

      var trackWidth = track.clientWidth;

      /* The 0% -> -50% CSS animation only loops seamlessly if a single
         "reel" (the half that gets scrolled through before the loop
         restarts) is at least as wide as the visible track -- otherwise
         the duplicated half runs out of content before the translate
         finishes, leaving a blank gap right before it jumps back to 0%.
         Message count/length is merchant-controlled and unpredictable,
         so keep repeating the unique message set until the reel is wide
         enough to fully cover the track no matter how short the text is. */
      var reelWidth = unitWidth;
      while (reelWidth < trackWidth) {
        unitNodes.forEach(function (n) {
          content.appendChild(n.cloneNode(true));
        });
        reelWidth = content.scrollWidth;
      }

      /* Duplicate the whole reel once more so there's a matching second
         half for the animation to scroll into. */
      var reelChildren = Array.prototype.slice.call(content.children);
      reelChildren.forEach(function (n) {
        content.appendChild(n.cloneNode(true));
      });

      /* translateX(-50%) assumes the doubled content is exactly twice the
         width of one reel, but flexbox `gap` adds one extra "seam" gap
         between the two reels that doubling doesn't produce inside a
         single reel -- so -50% overshoots the true seam by half a gap,
         which is what caused the visible snap/blink every time the loop
         restarted. Measure the real pixel offset of the second reel's
         first item and drive the animation off that instead. */
      var shiftPx = content.children[reelChildren.length].offsetLeft;
      content.style.setProperty("--marquee-shift", "-" + shiftPx + "px");

      /* Padding the reel makes it wider than the merchant's raw message
         set, so scale the configured "loop speed" duration proportionally
         -- otherwise the ticker would visibly speed up whenever padding
         was needed. */
      var baseDuration = wrapper
        ? parseFloat(getComputedStyle(wrapper).getPropertyValue("--marquee-base-duration"))
        : NaN;
      if (!baseDuration) baseDuration = 30;
      content.style.animationDuration = (baseDuration * (shiftPx / unitWidth)) + "s";
    }

    build();

    var resizeTimer;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(build, 200);
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initSpiLanguageFlags();
    initSpiMarqueeCarousel();
    initSpiMarqueeScroll();
  });
} else {
  initSpiLanguageFlags();
  initSpiMarqueeCarousel();
  initSpiMarqueeScroll();
}
